import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CommissionPromoterAdditional} from '../../model/commission-promoter-additional';
import {CatalogModel} from '../../../app/model/other-catalogs-models';
import {CommissionPromoterAdditionalService} from 'src/oldApp//services/commission-promoter-additional.service';
import {UtilitiesService} from 'src/app/services/utilities.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {isNullOrUndefined} from 'util';
import {catchError, tap} from 'rxjs/operators';
import {forkJoin, of, throwError} from 'rxjs';
import {CatEmployeeJobService} from 'src/app/services/cat-employee-job.service';
import {DataTableDirective} from 'angular-datatables';

@Component({
  selector: 'app-modal-commission-promoter-additional',
  templateUrl: './modal-commission-promoter-additional.component.html',
  styleUrls: ['./modal-commission-promoter-additional.component.css']
})
export class ModalCommissionPromoterAdditionalComponent implements OnInit {

  @Input() commissionPromoter:CommissionPromoterAdditional;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public valid:boolean=false;
  public error:boolean=false;
  public viewStatus:number=1;
  public formIsLocked:boolean=false;
  public details:string=null;
  public title:string=null;
  public hidden:boolean=true;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha ingresado la siguiente información. Está seguro de guardar?';

  // catalogos
  public listCommissions:CommissionPromoterAdditional[]=[];
  public listCommissionsFiltered:CommissionPromoterAdditional[]=[];

  public employeeJobsCatalog:CatalogModel[]=[];
  public businessProductsCatalog:CatalogModel[]=[];
  public ownerTypesCatalog:CatalogModel[]=[];
  public productsCatalog:CatalogModel[]=[];
  public afiliatesCatalog:CatalogModel[]=[];
  public paymentTermsCatalog:CatalogModel[]=[];

  public selectedEmployeeJobsDD:string[]=[];
  public selectedBusinessProductsDD:string[]=[];
  public selectedOwnerTypesDD:any[]=[];
  public selectedProductsDD:any[] = [];
  public selectedAfiliatesDD:any[]=[];
  public selectedPaymentTermsDD:any[]=[];

  public selectedEmployeeJobs:any[]=[];
  public selectedBusinessProducts:any[]=[];
  public selectedOwnerTypes:any[]=[];
  public selectedProducts:any[] = [];
  public selectedAfiliates:any[]=[];
  public selectedPaymentTerms:any[]=[];

  // mascaras
  public customPatterns={
    '0':{pattern:new RegExp('-|[0-9]')},
    '9':{pattern:new RegExp('[0-9]')},
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                         // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},     // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  // Opciones de Datatable
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;

  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      // { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 5,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  constructor(
    private commissionPromoterAdditionalService:CommissionPromoterAdditionalService,
    private catEmployeeJobService:CatEmployeeJobService,
    private utils:UtilitiesService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    console.log(">>> this.commissionPromoter= ", this.commissionPromoter);

    if(this.mode === "edit" && this.commissionPromoter.commissionId != null && this.commissionPromoter.commissionId > 0) {
      this.title = '<i class="icon-pencil"></i>&nbsp;&nbsp;Editar Comisión';
      this.getCatalogs(this.commissionPromoter.commissionId);
    }

    if(this.mode==='create') {
      this.title = '<i class="icon-plus"></i>&nbsp;&nbsp;Crear Comisines';
      this.getCatalogs(0);
    }

    if(this.mode==='detail' || this.mode==='delete' || this.mode==="toggleActive") {
      if(this.mode==='detail') this.confirmTitle = '<i class="icon-eye"></i>&nbsp;&nbsp;Detalle de Comisión';
      if(this.mode==='delete') this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se eliminará el siguiente registro. Esta seguro de eliminar?';
      if(this.mode==='toggleActive') {
        this.toggleActive();
        this.confirmTitle = this.commissionPromoter.activeId ? '<i class="icon-attention"></i>&nbsp;&nbsp;Se activará el siguiente registro. Esta seguro de activar?' : '<i class="icon-attention"></i>&nbsp;&nbsp;Se desactivará el siguiente registro. Esta seguro de desactivar?';
      }
      this.details = this.getDetails();
      this.viewStatus = 2;
    }

    let modalContent:any = $('.modal-content');
    modalContent.draggable({
      handle: '.card-header'
      // , drag: function() {
      //   document.querySelector<HTMLElement>(".card-modal").classList.add("backdrop-modal");
      // }
    });
  }

  isValid=()=> {
    this.valid = true;

    let errors=[];
    if(this.employeeJobError()) errors.push('&bull; Seleccione un puesto!');
    if(this.businessProductError()) errors.push('&bull; Seleccione una linea de negocio!');
    if(this.selectedProductsError()) errors.push('&bull; Seleccione un producto!');
    if(this.selectedAfiliatesError()) errors.push('&bull; Seleccione un convenio!');
    if(this.selectedPaymentTermsError()) errors.push('&bull; Seleccione un plazo!');
    if(this.commissionError()) errors.push('&bull; Ingrese una comisión!');
    if(this.commissionMaxError()) errors.push('&bull; Ingrese una comisión máxima!');
    if(this.collectCapitalAmountMinError()) errors.push('&bull; Ingrese un monto colocado mínimo!');
    if(this.collectCapitalAmountMaxError()) errors.push('&bull; Ingrese un monto colocado máximo!');
    if(this.collectCapitalAmountMinMaxError()) errors.push('&bull; El monto capital mínimo no puede ser mayor al monto máximo!');

    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }

    if(this.valid){
      this.details = this.getDetails();
      this.viewStatus = 2;
    }else{
      this.viewStatus = 1;
      this.details = null;
    }
  }
  getDetails=()=> {
    let details = "<table cellpadding=\"4\"><tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.commission + "%]</td></tr>";
    details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Máxima:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.commissionMax + "%]</td></tr>";
    details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto Colocado:</font></b></td><td valign=\"top\">De [" + this.commissionPromoter.collectCapitalAmountMin + "] a [" + this.commissionPromoter.collectCapitalAmountMax + "]</td></tr>";

    if(this.mode === "edit" || this.mode === "create") {
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puesto:</font></b></td><td valign=\"top\">[" + this.getSelectedEmployees() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Linea de Negocio:</font></b></td><td valign=\"top\">[" + this.getSelectedBusinessProducts() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Tipo de Fondeo:</font></b></td><td valign=\"top\">[" + this.getSelectedOwnerTypes() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Producto:</font></b></td><td valign=\"top\">[" + this.getSelectedProducts() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenio:</font></b></td><td valign=\"top\">[" + this.getSelectedAfiliates() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazo:</font></b></td><td valign=\"top\">[" + this.getSelectedPaymentTerms() + "]</td></tr>";
    }else{
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puesto:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.employeeJobDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Linea de Negocio:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.businessProductDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Tipo de Fondeo:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.ownerTypeDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Producto:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.productosCOEDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenio:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.afiliateDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazo:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.paymentDescr + "]</td></tr>";
      // details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Id Empleado:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.employeeId + "]</td></tr>";
      // details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Id Credito:</font></b></td><td valign=\"top\">[" + this.commissionPromoter.creditId + "]</td></tr>";
    }

    if(this.mode==='detail' || this.mode==='delete')
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.commissionPromoter.activeId ? '[Sí]' : '[No]') + "</td></tr>";

    details = details + "</table>";
    return details;
  }

  closeConfirm=()=> {
    if(this.mode==="delete" || this.mode==="toggleActive" || this.mode==="detail"){
      this.modalService.dismissAll();
    }else{
      this.viewStatus = 1;
      this.details = null;
    }
  }

  save=()=> {
    if(this.error){
      this.modalService.dismissAll('failure');
      return;
    }

    this.viewStatus=0;
    delete this.commissionPromoter.businessProductDescr;
    delete this.commissionPromoter.ownerTypeDescr;
    delete this.commissionPromoter.productosCOEDescr;
    delete this.commissionPromoter.afiliateDescr;
    delete this.commissionPromoter.paymentDescr;
    delete this.commissionPromoter.employeeJobDescr;
    delete this.commissionPromoter.createUserId;
    delete this.commissionPromoter.createUserName;
    delete this.commissionPromoter.createDate;
    delete this.commissionPromoter.modifUserName;
    delete this.commissionPromoter.modifDate;
    delete this.commissionPromoter.selected;

    if(this.mode==="delete" || this.mode==="toggleActive"){

      this.commissionPromoter.modifUserId=Number(localStorage.getItem('com_token'));

      if(this.mode==="delete"){
        this.commissionPromoterAdditionalService.delete(this.commissionPromoter)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El registro se ha eliminado correctamente!');
            }
            if(resp && resp.codeHttpStatus===409) {
              this.confirmTitle='<i class="icon-attention"></i>&nbsp;&nbsp; Error al eliminar!';
              this.details = '<h6>No se pude eliminar el registro seleccionado debido a reglas de negocio!</h6>';
              this.error = true;
            }
          });
      }

      if(this.mode==="toggleActive"){
        let status = this.commissionPromoter.activeId ? 'activado' : 'desactivado';
        this.commissionPromoterAdditionalService.saveUpdate(this.commissionPromoter)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El registro se ha ' + status + ' correctamente!');
            }
          });
      }
    }

    if(this.mode==="create" || this.mode==="edit"){

      this.commissionPromoter.collectCapitalAmountMin = !isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMin) ? this.commissionPromoter.collectCapitalAmountMin : 0;
      this.commissionPromoter.collectCapitalAmountMax = !isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMax) ? this.commissionPromoter.collectCapitalAmountMax : 0;

      if(this.mode === 'edit' && this.commissionPromoter.commissionId != null && this.commissionPromoter.commissionId > 0){
        this.commissionPromoter.modifUserId = Number(localStorage.getItem('com_token'));
        console.log(">> this.commissionPromoter=", this.commissionPromoter);
        this.saveCommission(this.commissionPromoter);
      }
      if(this.mode === 'create'){
        this.commissionPromoter.createUserId = Number(localStorage.getItem('com_token'));
        console.log(">> this.commissionPromoter=", this.commissionPromoter);
        let request = {
          // "employeeId": this.commissionPromoter.employeeId,
          // "creditId": this.commissionPromoter.creditId,
          "commission": this.commissionPromoter.commission,
          "commissionMax": this.commissionPromoter.commissionMax,
          "collectCapitalAmountMin": this.commissionPromoter.collectCapitalAmountMin,
          "collectCapitalAmountMax": this.commissionPromoter.collectCapitalAmountMax,
          "createUserId": this.commissionPromoter.createUserId,
          "listEmployeeJobs": this.selectedEmployeeJobs.map(function(row) {
            return row.id;
          }),
          "listBusinessProducts": this.selectedBusinessProducts.map(function(row) {
            return row.id;
          }),
          "listOwnerTypes": this.selectedOwnerTypes.map(function(row) {
            return row.id;
          }),
          "listFinancingTypes": this.selectedProducts.map(function(row) {
            return row.id;
          }),
          "listPaymentTerms": this.selectedPaymentTerms.map(function(row) {
            return row.id;
          }),
          "listAfiliates": this.selectedAfiliates.map(function(row) {
            return row.id;
          })
        };
        this.saveNewCommissions(request);
      }
      /*else{
        this.listCommissionsFiltered=this.listCommissions.filter(it=> it.selected);
        console.log(">> Selected Items= ", this.listCommissionsFiltered);
        this.listCommissionsFiltered.forEach((commission, index)=> {
          commission.commission = this.commissionPromoter.commission;
          commission.commissionMax = this.commissionPromoter.commissionMax;
          commission.collectCapitalAmountMin = this.commissionPromoter.collectCapitalAmountMin;
          commission.collectCapitalAmountMax = this.commissionPromoter.collectCapitalAmountMax;
          commission.createUserId = Number(localStorage.getItem('com_token'));
          console.log(">> Save= ", commission);
          //this.saveCommission(commission);
        });
      }*/
    }
  }
  saveCommission=(model:CommissionPromoterAdditional)=>{
    this.commissionPromoterAdditionalService.saveUpdate(model)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            this.commissionPromoter.commissionId = resp.data.commissionId;
            this.modalService.dismissAll('success');
            this.toastr.success('La comisión se guardó correctamente!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
        })
      )
      .subscribe();
  }
  saveNewCommissions=(request:any)=>{
    console.log("----------------------------------------------------------------------------------------");
    console.log(request);
    console.log("----------------------------------------------------------------------------------------");
    this.commissionPromoterAdditionalService.saveUpdateNew(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            this.modalService.dismissAll('success');
            this.toastr.success('Las comisiones se guardaron correctamente!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
        })
      )
      .subscribe();
  }
  close=()=> {
    this.modalService.dismissAll('cancel');
  }

  // HELPERS
  employeeJobError=()=> !(this.selectedEmployeeJobs != null && this.selectedEmployeeJobs.length > 0);
  businessProductError=()=> !(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length > 0);
  selectedProductsError=()=> !(this.selectedProducts != null && this.selectedProducts.length > 0);
  selectedAfiliatesError=()=> !(this.selectedAfiliates != null && this.selectedAfiliates.length > 0);
  selectedPaymentTermsError=()=> !(this.selectedPaymentTerms != null && this.selectedPaymentTerms.length > 0);
  commissionError=()=> this.commissionPromoter.commission!==0 && !this.commissionPromoter.commission;
  commissionMaxError=()=> this.commissionPromoter.commissionMax!==0 && !this.commissionPromoter.commissionMax;
  collectCapitalAmountMinError=()=> isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMin);
  collectCapitalAmountMaxError=()=> isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMax);
  collectCapitalAmountMinMaxError=()=> !isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMin) &&
                                       !isNullOrUndefined(this.commissionPromoter.collectCapitalAmountMax) && (
                                         this.commissionPromoter.collectCapitalAmountMin > this.commissionPromoter.collectCapitalAmountMax
                                       );
  compare(a:any, b:any) {
    const arr = [];
    return arr.indexOf(a.id) - arr.indexOf(b.id);
  }
  updateCommission=e=> this.commissionPromoter.commission=!e || e.trim()===''?null:Number(e);
  updateCommissionMax=e=> this.commissionPromoter.commissionMax=!e || e.trim()===''?null:Number(e);
  updateCollectCapitalAmountMin=e=> this.commissionPromoter.collectCapitalAmountMin=!e || e.trim()===''?null:Number(e);
  updateCollectCapitalAmountMax=e=> this.commissionPromoter.collectCapitalAmountMax=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.commissionPromoter.activeId=!this.commissionPromoter.activeId;
  getSelectedEmployees=()=>{
    let value:string = '';
    this.selectedEmployeeJobs.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedBusinessProducts=()=>{
    let value:string = '';
    this.selectedBusinessProducts.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedOwnerTypes=()=>{
    let value:string = '';
    this.selectedOwnerTypes.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedProducts=()=>{
    let value:string = '';
    this.selectedProducts.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedAfiliates=()=>{
    let value:string = '';
    this.selectedAfiliates.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedPaymentTerms=()=>{
    let value:string = '';
    this.selectedPaymentTerms.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }

  // EVENTS
  employeeJobChange=e=> {
    if(e.length > 0){
      this.selectedEmployeeJobs=e;
      console.log(">> this.selectedEmployeeJobs= ", this.selectedEmployeeJobs);
      console.log(">> this.selectedEmployeeJobsDD=", this.selectedEmployeeJobsDD);
    } else {
      this.selectedEmployeeJobs=[];
    }
  };
  businessProductChange=e=>{

    this.selectedProducts=[];
    this.selectedAfiliates=[];
    this.selectedPaymentTerms=[];

    this.selectedProductsDD=[];
    this.selectedAfiliatesDD=[];
    this.selectedPaymentTermsDD=[];

    if(e.length > 0){
      this.selectedBusinessProducts=e;
      console.log(">> this.selectedBusinessProducts= ", this.selectedBusinessProducts);
      console.log(">> this.selectedBusinessProductsDD= ", this.selectedBusinessProductsDD);

      //CARGA PRODUCTOS X LINEA DE NEGOCIO SELECCIONADOS
      if(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length>0){

        this.productsCatalog=[];
        this.afiliatesCatalog=[];
        this.paymentTermsCatalog=[];

        let businessProductId:number[]=[];
        this.selectedBusinessProducts.forEach((el)=>{
          businessProductId.push(el.id);
        });

        this.commissionPromoterAdditionalService.getProductsByBusinessLine(businessProductId)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.productsCatalog = resp.data;
            }
          });
      }
    }else{
      this.selectedBusinessProducts=[];
    }
  };
  ownerTypeChange=e=>{
    if(e.length > 0){
      this.selectedOwnerTypes=e;
      console.log(">> this.selectedOwnerTypes= ", this.selectedOwnerTypes);
      console.log(">> this.selectedOwnerTypesDD= ", this.selectedOwnerTypesDD);
    }else{
      this.selectedOwnerTypes=[];
    }
  };
  productsChange=e=> {

    this.selectedAfiliates=[];
    this.selectedPaymentTerms=[];

    this.selectedAfiliatesDD=[];
    this.selectedPaymentTermsDD=[];

    if(e.length > 0){
      this.selectedProducts=e;
      console.log(">> this.selectedProducts= ", this.selectedProducts);
      console.log(">> this.selectedProductsDD= ", this.selectedProductsDD);

      //CARGA CONVENIOS X PRODUCTOS SELECCIONADOS
      if(this.selectedProducts != null && this.selectedProducts.length > 0){

        this.afiliatesCatalog=[];
        this.paymentTermsCatalog=[];

        let financingTypeId:number[]=[];
        this.selectedProducts.forEach((el)=>{
          financingTypeId.push(el.id);
        });

        this.commissionPromoterAdditionalService.getAfiliatesByProduct(financingTypeId)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.afiliatesCatalog=resp.data;
            }
          });
      }
    }else{
      this.selectedProducts=[];
    }
  }
  afiliatesChange=e=> {

    this.selectedPaymentTerms=[];
    this.selectedPaymentTermsDD=[];

    if(e.length > 0) {
      this.selectedAfiliates = e;
      console.log(">> this.selectedAfiliates= ", this.selectedAfiliates);
      console.log(">> this.selectedAfiliatesDD= ", this.selectedAfiliatesDD);

      //CARGAR PLAZOS X CONVENIOS SELECCIONADOS
      if(this.selectedAfiliates != null && this.selectedAfiliates.length > 0){

        this.paymentTermsCatalog=[];

        let afiliates:number[]=[];
        this.selectedAfiliates.forEach((el)=>{
          if(el.id > 0) afiliates.push(el.id);
        });

        this.commissionPromoterAdditionalService.getPaymentTermsByAfiliate(afiliates)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.paymentTermsCatalog=resp.data.filter(e => e.id!==21 && e.id!==22 && e.id!==23);
            }
          });
      }
    }else{
      this.selectedAfiliates = [];
    }
  }
  paymentTermsChange=e=> {
    if(e.length > 0) {
      this.selectedPaymentTerms = e;
      console.log(">> this.selectedPaymentTerms= ", this.selectedPaymentTerms);
      console.log(">> this.selectedPaymentTermsDD= ", this.selectedPaymentTermsDD);
    } else {
      this.selectedPaymentTerms = [];
    }
  }

  // INFO
  getCatalogs=(commissionSaleId:number)=> {
    this.viewStatus=0;
    forkJoin(
      this.catEmployeeJobService.catalog(),                         //Puestos
      this.commissionPromoterAdditionalService.getBusinessLines(),  //Líneas de negocio
      this.commissionPromoterAdditionalService.getOwnerTypes()      //Tipos de fondeo
    )
      .pipe(
        tap(([empJobResp, bpResp, ownerResp]:[any, any, any])=> {
          if(empJobResp && bpResp && ownerResp) {

            this.employeeJobsCatalog=empJobResp.data.filter(e=> e.id<3);
            this.businessProductsCatalog=bpResp.data;
            this.ownerTypesCatalog = ownerResp.data;

            if(commissionSaleId > 0){
              let listBp:number[]=[];
              let listProd:number[]=[];
              let listAfi:number[]=[];

              let idEmp:number = parseInt(this.commissionPromoter.employeeJobId.toString());
              let idBp:number = parseInt(this.commissionPromoter.businessProductId.toString());
              let idOwn:number = parseInt(this.commissionPromoter.ownerTypeId.toString());
              let idProd = parseInt(this.commissionPromoter.productosCOEId.toString());
              let idAfi = parseInt(this.commissionPromoter.afiliateId.toString());
              let idPay = parseInt(this.commissionPromoter.paymentId.toString());

              listBp.push(idBp);
              listProd.push(idProd);
              listAfi.push(idAfi);

              this.selectedEmployeeJobs=empJobResp.data.filter(e=> e.id===idEmp);
              this.selectedEmployeeJobsDD=empJobResp.data.filter(e=> e.id===idEmp).map(function(e){
                return parseInt(e.id);
              });

              this.selectedBusinessProducts=bpResp.data.filter(e=> e.id===idBp);
              this.selectedBusinessProductsDD=bpResp.data.filter(e=> e.id===idBp).map(function(e){
                return parseInt(e.id);
              });

              this.selectedOwnerTypes=ownerResp.data.filter(e=> e.id===idOwn);
              this.selectedOwnerTypesDD=ownerResp.data.filter(e=> e.id===idOwn).map(function(e){
                return parseInt(e.id);
              });

              this.loadProducts(listBp, idProd);
              this.loadAfiliates(listProd, idAfi);
              this.loadPaymentTerms(listAfi, idPay);
            }else{
              this.viewStatus=1;
            }
          }
          else throwError;
        }),
        catchError(error=> {
          //console.log(error);
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
        })
      )
      .subscribe();
  }
  loadProducts=(businessProductId:number[], idProd:number)=> {
    if(businessProductId != null && idProd != null){
      this.commissionPromoterAdditionalService.getProductsByBusinessLine(businessProductId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.productsCatalog = resp.data;
            this.selectedProducts=resp.data.filter(e=> e.id===idProd);
            this.selectedProductsDD=resp.data.filter(e=> e.id===idProd).map(function(e){
               return parseInt(e.id);
            });
          }
        });
    }
  }
  loadAfiliates=(financingTypeId:number[], idAfi:number)=>{
    if(financingTypeId != null && idAfi != null){
      this.commissionPromoterAdditionalService.getAfiliatesByProduct(financingTypeId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.afiliatesCatalog=resp.data;
            this.selectedAfiliates=resp.data.filter(e=> e.id===idAfi);
            this.selectedAfiliatesDD=resp.data.filter(e=> e.id===idAfi).map(function(e){
               return parseInt(e.id);
            });
          }
        });
    }
  }
  loadPaymentTerms=(afiliateId:number[], idPay:number)=>{
    if(afiliateId != null && idPay != null){
      this.commissionPromoterAdditionalService.getPaymentTermsByAfiliate(afiliateId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.paymentTermsCatalog=resp.data;
            this.selectedPaymentTerms=resp.data.filter(e=> e.id===idPay);
            this.selectedPaymentTermsDD=resp.data.filter(e=> e.id===idPay).map(function(e){
              return parseInt(e.id);
            });
            this.viewStatus=1;
          }
        });
    }
  }

}
